<template>
    <div>
        <div v-for="(q, i) in quotes" class="max-w-2xl my-10 flex items-center">
            <div class="pr-8 text-indigo-500 items-center">
                <div>
                    {{ i + 1}})
                </div>
                <button @click="$emit('load', i)" class="text-white mt-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 fill-current" viewBox="0 0 24 24"><path d="M13.723 18.654l-3.61 3.609c-2.316 2.315-6.063 2.315-8.378 0-1.12-1.118-1.735-2.606-1.735-4.188 0-1.582.615-3.07 1.734-4.189l4.866-4.865c2.355-2.355 6.114-2.262 8.377 0 .453.453.81.973 1.089 1.527l-1.593 1.592c-.18-.613-.5-1.189-.964-1.652-1.448-1.448-3.93-1.51-5.439-.001l-.001.002-4.867 4.865c-1.5 1.499-1.5 3.941 0 5.44 1.517 1.517 3.958 1.488 5.442 0l2.425-2.424c.993.284 1.791.335 2.654.284zm.161-16.918l-3.574 3.576c.847-.05 1.655 0 2.653.283l2.393-2.389c1.498-1.502 3.94-1.5 5.44-.001 1.517 1.518 1.486 3.959 0 5.442l-4.831 4.831-.003.002c-1.438 1.437-3.886 1.552-5.439-.002-.473-.474-.785-1.042-.956-1.643l-.084.068-1.517 1.515c.28.556.635 1.075 1.088 1.528 2.245 2.245 6.004 2.374 8.378 0l4.832-4.831c2.314-2.316 2.316-6.062-.001-8.377-2.317-2.321-6.067-2.313-8.379-.002z"/></svg>
                </button>
            </div>
            <div>
                <p class="text-lg">{{ q.quote }}</p>
                <p class="text-indigo-200 pt-2">
                    — {{ q.byline}}
                    <a v-if="q.url" :href="q.url">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                             class="inline h-4 hover:text-blue-200 text-white fill-current ml-3">
                            <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 11.701c0 2.857-1.869 4.779-4.5 5.299l-.498-1.063c1.219-.459 2.001-1.822 2.001-2.929h-2.003v-5.008h5v3.701zm6 0c0 2.857-1.869 4.779-4.5 5.299l-.498-1.063c1.219-.459 2.001-1.822 2.001-2.929h-2.003v-5.008h5v3.701z"></path>
                        </svg>
                    </a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'QuoteList',
    props: {
      quotes: Array,
    }
  }
</script>

<style scoped>

</style>
